import myBenefits from 'theSource/assets/HomeTiles/myBenefits.jpg';
import myCompany from 'theSource/assets/HomeTiles/myCompany.jpg';
import myInbox from 'theSource/assets/HomeTiles/myInbox.jpg';
import myPaycheck from 'theSource/assets/HomeTiles/myPaycheck.jpg';
import healthWealth from 'theSource/assets/HomeTiles/healthWealth.jpg';
import { ROUTES } from 'theSource/app/routes';

export const TILES = [
  {
    label: 'myBenefitsTileLabel',
    path: ROUTES.additional.benefits.myBenefits.path,
    backgroundImage: myBenefits,
    lookupCode: 'my_benefits',
  },
  {
    label: 'myInboxTileLabel',
    path: ROUTES.main.inbox.path,
    backgroundImage: myInbox,
    lookupCode: 'my_inbox',
  },
  {
    label: 'myPaycheckTileLabel',
    path: ROUTES.main.home.path,
    backgroundImage: myPaycheck,
    lookupCode: 'see_my_paycheck',
  },
  {
    label: 'myCompanyTileLabel',
    path: ROUTES.additional.company.myCompany.path,
    backgroundImage: myCompany,
    lookupCode: 'my_company',
  },
];

export const EVIVE_TILES = [
  {
    label: 'healthWealthLabel',
    path: '', // this will get populated during the mapTiles function for SSO capabilites
    backgroundImage: healthWealth,
    lookupCode: 'my_inbox',
  },
  {
    label: 'myBenefitCoveragesLabel',
    path: ROUTES.additional.benefits.myBenefits.path,
    backgroundImage: myBenefits,
    lookupCode: 'my_benefits',
  },
];

export const GET_TILES_QUERY_KEY = ['tiles'] as const;
